export default __webpack_public_path__ + "static/media/edit.55522b47.png";